// @ts-nocheck
import { supabase } from '@/lib/supabase';

// Membership hierarchy from highest to lowest tier
const MEMBERSHIP_HIERARCHY = [
  'admin',
  'athlete_hof',
  'athlete_mvp', 
  'athlete_premium',
  'athlete_last_chance',
  'college_coach',
  'hs_coach',
  'club_coach',
  'scout',
  'parent',
  'parent_free',
  'vendor_press',
  'vendor_video',
  'customer',
  'athlete_free'
];

/**
 * Determines the highest tier membership from a list of active memberships
 */
export const getHighestTierMembership = (activeMemberships: string[]): string => {
  if (!activeMemberships || activeMemberships.length === 0) {
    return 'athlete_free'; // Default fallback
  }

  // Find the membership with the lowest index (highest tier)
  let highestTier = 'athlete_free';
  let highestTierIndex = MEMBERSHIP_HIERARCHY.indexOf('athlete_free');

  for (const membership of activeMemberships) {
    const membershipIndex = MEMBERSHIP_HIERARCHY.indexOf(membership);
    if (membershipIndex !== -1 && membershipIndex < highestTierIndex) {
      highestTier = membership;
      highestTierIndex = membershipIndex;
    }
  }

  return highestTier;
};

/**
 * Updates the profile's active_membership_slug based on current active memberships
 */
export const updateProfileActiveMembership = async (profileId: string): Promise<void> => {
  try {
    console.log('🔄 updateProfileActiveMembership: Starting for profile:', profileId);

    // Fetch all active memberships for the profile
    const { data: memberships, error: membershipsError } = await supabase
      .from('profile_memberships')
      .select('membership_slug')
      .eq('profile_id', profileId)
      .eq('is_active', true);

    if (membershipsError) {
      console.error('❌ updateProfileActiveMembership: Error fetching memberships:', membershipsError);
      throw membershipsError;
    }

    console.log('📊 updateProfileActiveMembership: Found active memberships:', memberships);

    // Get the membership slugs
    const membershipSlugs = memberships?.map(m => m.membership_slug) || [];
    
    // Determine the highest tier membership
    const highestTierMembership = getHighestTierMembership(membershipSlugs);
    
    console.log('🏆 updateProfileActiveMembership: Highest tier membership:', highestTierMembership);

    // Update the profile's active_membership_slug
    const { error: updateError } = await supabase
      .from('profiles')
      .update({ active_membership_slug: highestTierMembership })
      .eq('id', profileId);

    if (updateError) {
      console.error('❌ updateProfileActiveMembership: Error updating profile:', updateError);
      throw updateError;
    }

    console.log('✅ updateProfileActiveMembership: Successfully updated profile with membership:', highestTierMembership);
  } catch (error) {
    console.error('💥 updateProfileActiveMembership: Exception:', error);
    throw error;
  }
};